import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { TOAST_CONTAINER_CLASS_NAME } from './utils';
import { PrimaryButton } from '../../components/Button';
import { theme } from '../../styles/theme';
import { NOTIFICATION_Z_INDEX } from '../../styles/zIndexes';
import { IconWrapper } from '../../components/Icon';

export const StyledToastContainer = styled(ToastContainer)`
  .${TOAST_CONTAINER_CLASS_NAME} {
    width: 360px;
    min-height: unset;
    padding: 16px;
    border-radius: 8px;
    cursor: default;
    font: inherit;
    // per design, toast message color is the same for light and dark modes
    background-color: #2a2a2a;
    box-shadow: ${theme.effects.shadow2};
  }
  .Toastify__progress-bar {
    background: green;
  }
  .Toastify__toast-body {
    margin: 0;
    padding: 0;
  }
  .Toastify__toast-container {
    /* compare to .modals.dimmer.visible  */
    z-index: ${NOTIFICATION_Z_INDEX} !important;
  }
`;

export const Container = styled.div`
  display: flex;
  row-gap: 4px;
  flex-direction: column;
  align-items: flex-start;
`;
export const MessageContainer = styled.div`
  display: flex;
  width: 100%;
`;
export const StyledIconWrapper = styled(IconWrapper)`
  margin-right: 12px;
  border-radius: 8px;
`;
export const ToastMessage = styled.div`
  flex: 1;
  align-self: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${theme.colors.white};
`;
export const StyledButton = styled(PrimaryButton)`
  margin-left: auto;
`;
